// extracted by mini-css-extract-plugin
export default {"loading-wrapper":"agreement_loading-wrapper__mGVRe"};